import { Account, Beneficiary, Transaction } from './'
import { Merchant } from './Merchant'

export enum WithdrawStatus {
  UNAUTHORIZED = 'unauthorized',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  INQUIRIED = 'inquiried',
  PROCESS = 'process',
  FAILED = 'failed',
  SENT = 'sent',
  UNSENT = 'unsent',
  SUCCEED = 'succeed',
  OBSCURE = 'obscure',
  SUSPECTED = 'suspected',
  DECLINED = 'declined',
  WAITING = 'waiting',
  DRAFT = 'draft',
  REVIEW = 'review',
  REJECTED = 'rejected',
}

export class Withdraw {
  constructor(
    public id: string,
    public createdTime: Date,
    public updatedTime: Date,
    public accountId: string,
    public transactionId: number,
    public status: WithdrawStatus,
    public prefix: string,
    public address: string,
    public addressName: string,
    public amount: number,
    public feeAmount: number,
    public notes: string,
    public reference: string,
    public networkId: string,
    public statusMessage?: string,
    public account?: Account,
    public beneficiaryId?: string,
    public beneficiary?: Beneficiary,
    public transaction?: Transaction,
    public network?: any,
    public referenceData?: any,
    public merchantId?: number,
    public merchant?: Merchant,
  ) {}
}
